import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function ForbiddenPage() {
  return (
    <div className="min-h-screen bg-maritime-950 text-white flex items-center justify-center px-4 py-32 relative overflow-hidden">
      <SEO
        title="403 - Adgang nægtet | JT transportsejlads"
        description="Du har ikke tilladelse til at tilgå denne side. Navigér tilbage til forsiden hos JT transportsejlads."
      />

      <div className="absolute inset-0 flex items-center justify-center opacity-5 pointer-events-none" aria-hidden="true">
        <i className="fa-solid fa-shield-halved text-[32rem]" />
      </div>

      <div className="relative z-10 max-w-lg mx-auto text-center space-y-6">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-cyan-950/80 border border-cyan-500/40 text-cyan-400 text-3xl shadow-inner mx-auto">
          <i className="fa-solid fa-lock" aria-hidden="true" />
        </div>

        <span className="text-sm font-bold uppercase tracking-widest text-cyan-400 block">
          Fejlkode 403
        </span>

        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white">
          Adgang nægtet
        </h1>

        <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
          Du har ikke de nødvendige tilladelser til at tilgå denne sektion eller ressource.
        </p>

        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-cyan-600 hover:bg-cyan-500 text-white font-semibold text-sm transition-all shadow-lg"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Tilbage til forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-white/10 hover:bg-white/15 text-white font-semibold text-sm border border-white/20 transition-all"
          >
            <i className="fa-solid fa-envelope text-xs text-cyan-400" aria-hidden="true" />
            <span>Kontakt os</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
